export const REPRESENTATIVES_QUERY_STRING = {
  representatives_multiple_profile: 'representatives_multiple_profile',
  representatives_agencies_pagination: 'agencies_pagination',
  representatives_single_profile: 'representatives_single_profile',
  representatives_single_profile_attached_media: 'representatives_single_profile_attached_media',
  representatives_single_profile_hidden_media: 'representatives_single_profile_hidden_image',
};
